import {
  footerID,
  mainLayoutID,
  leftNavID,
  rightNavID,
  secondaryNavID,
  topNavQuerySelector,
} from '../constants/layoutConstants';

const focusableSelectors = [
  'a',
  'button',
  'input',
  'select',
  'textarea',
  '[tabindex]:not([tabindex="-1"])',
];
export const FOCUSABLE_QUERY = focusableSelectors.join(', ');

const getQuerySelectors = () => {
  const leftNav = document.getElementById(leftNavID);
  const mainLayout = document.getElementById(mainLayoutID);
  const rightNav = document.getElementById(rightNavID);
  const secondaryNav = document.getElementById(secondaryNavID);
  const footer = document.getElementById(footerID);
  const topNav = document.querySelector(topNavQuerySelector);
  return {
    topNav: {
      element: topNav,
      firstLink: topNav?.querySelector(FOCUSABLE_QUERY) as HTMLAnchorElement,
    },
    leftNav: {
      element: leftNav,
      firstLink: leftNav?.querySelector(FOCUSABLE_QUERY) as HTMLAnchorElement,
      // note: NodeList changes dynamically in response to user interaction
      // -> always fetch these elements when needed
      getLastLink: () => {
        const els = leftNav?.querySelectorAll(FOCUSABLE_QUERY);
        return els ? (els[els.length - 1] as HTMLAnchorElement) : null;
      },
      getFocusableElements: () => leftNav?.querySelectorAll(FOCUSABLE_QUERY),
      nearestMatch: topNav,
    },
    mainLayout: {
      element: mainLayout,
      firstLink: mainLayout?.querySelector(FOCUSABLE_QUERY) as HTMLAnchorElement,
    },
    rightNav: {
      element: rightNav,
      firstLink: rightNav?.querySelector('a') as HTMLAnchorElement,
      // note: NodeList changes dynamically in response to user interaction
      // -> always fetch these elements when needed
      getLastLink: () => {
        const els = rightNav?.querySelectorAll(FOCUSABLE_QUERY);
        return els ? (els[els.length - 1] as HTMLAnchorElement) : null;
      },
      getFocusableElements: () => rightNav?.querySelectorAll(FOCUSABLE_QUERY),
      nearestMatch: footer,
    },
    secondaryNav: {
      element: secondaryNav,
      firstLink: secondaryNav?.querySelector(FOCUSABLE_QUERY) as HTMLAnchorElement,
      nearestMatch: topNav,
    },
    footer: {
      element: footer,
      firstLink: footer?.querySelector(FOCUSABLE_QUERY) as HTMLAnchorElement,
    },
  };
};

export default getQuerySelectors;
